export interface I18n {
  MY_PRIVACY: string
  MY_PROFILE: string
  MY_INSURANCE: string
  MY_PROFILE_EDIT: string
  PRICE_ADJUSTMENTS: string
  WELCOME: string
  VAC_POLICY_TYPE: (policyType: string) => string
  VAC_COVERAGE_TITLE: string
  VAC_COVERAGE_NO_COVERAGE: string
  VAC_COVERAGE_SUBMIT_INSTRUCTIONS: string
  VAC_COVERAGE_SUBMIT_BUTTON: string
  VAC_COVERAGE_ALREADY_SENT_NOTICE: string
  VAC_DOCUMENT_RECEIVED: (date: string) => string
  VAC_UNDER_REVIEW: string
  VAC_PRE_COVERAGE_ACTIVE: string
  VAC_ACTIVATE_INSTRUCTIONS: string
  VAC_PRE_COVERAGE_TITLE: string
  VAC_COVERAGE_PLAN_TITLE: string
  VAC_CURRENT_PERIOD_SUFFIX: string
  VAC_REMAINING_COVERAGE: (grams: number) => string
  VAC_CURRENT_PERIOD_SPAN: (startDate: string, endDate: string) => string
  VAC_NEXT_PERIOD_NOTICE: string
}

export const getI18n = (language: string): I18n => {
  const frCA = language === 'fr-CA'
  return {
    MY_PRIVACY: frCA ? 'Ma Confidentialité' : 'My Privacy',
    MY_PROFILE: frCA ? 'Mon Profil' : 'My Profile',
    MY_INSURANCE: frCA ? 'Mon Assurance' : 'My Insurance',
    MY_PROFILE_EDIT: frCA ? 'Mon Profil - Modifier' : 'My Profile - Edit',
    PRICE_ADJUSTMENTS: frCA ? 'Remise:' : 'Price Adjustments:',
    WELCOME: frCA ? 'Bienvenue ' : 'Welcome ',
    VAC_POLICY_TYPE: (policyType: string) => `Policy Type: ${policyType}`,
    VAC_COVERAGE_TITLE: frCA ? 'Informations sur la couverture' : 'Coverage Information',
    VAC_COVERAGE_NO_COVERAGE: frCA ? 'Aucune couverture ACC' : 'No VAC coverage',
    VAC_COVERAGE_SUBMIT_INSTRUCTIONS: frCA
      ? 'Soumettez votre lettre d\'approbation de Medavie Croix Bleue à l\'aide de l\'outil de soumission en ligne.'
      : 'Submit your approval letter from Medavie Blue Cross using the online submission tool.',
    VAC_COVERAGE_SUBMIT_BUTTON: frCA ? ' Soumettre votre lettre d\'approbation' : 'Submit your approval letter',
    VAC_COVERAGE_ALREADY_SENT_NOTICE: frCA
      ? 'Si vous l\'avez déjà soumise, veuillez prévoir un délai de 1 à 3 jours ouvrables pour son traitement. Il n\'est pas nécessaire de la soumettre à nouveau.'
      : 'If you\'ve already sent it, please allow 1-3 business days for processing, there\'s no need to submit again.',
    VAC_DOCUMENT_RECEIVED: (date: string) => frCA ? `Document reçu : ${date}` : `Document received: ${date}`,
    VAC_UNDER_REVIEW: frCA
      ? 'Votre lettre d\'approbation d\'ACC est actuellement à l\'étude. Veuillez prévoir un délai de 1 à 3 jours ouvrables pour son traitement.'
      : 'Your VAC approval letter is under review, please allow 1-3 business days for processing.',
    VAC_PRE_COVERAGE_ACTIVE: frCA
      ? 'Vous utilisez actuellement la couverture Pré-ACC.'
      : 'You are currently using Pre VAC coverage.',
    VAC_ACTIVATE_INSTRUCTIONS: frCA
      ? 'Pour activer votre couverture ACC, veuillez soumettre votre lettre d\'approbation de Medavie Croix Bleue à l\'aide de l\'outil de soumission en ligne.'
      : 'To activate your VAC coverage, submit your approval letter from Medavie Blue Cross using the online submission tool.',
    VAC_PRE_COVERAGE_TITLE: frCA ? 'Pré-couverture ACC' : 'Pre-VAC Coverage',
    VAC_COVERAGE_PLAN_TITLE: frCA ? 'Couverture ACC' : 'VAC Coverage',
    VAC_CURRENT_PERIOD_SUFFIX: frCA ? 'Période actuelle' : 'Current Period',
    VAC_REMAINING_COVERAGE: (grams: number) => frCA ? `Couverture restante : ${grams} grammes` : `Remaining Coverage: ${grams} grams`,
    VAC_CURRENT_PERIOD_SPAN: (startDate: string, endDate: string) => frCA ? `Période actuelle : du ${startDate} au ${endDate}` : `Current period: ${startDate} to ${endDate}`,
    VAC_NEXT_PERIOD_NOTICE: frCA
      ? 'Votre prochaine période de couverture débute le lendemain de la date de fin de la période actuelle.'
      : 'Your next coverage period starts the day after the current period end date',
  }
}
